export const ai = {
  adCopy: {
    headlines: [
      'Shop Acme — Free 2-Day Shipping',
      'Premium Gear, Honest Prices',
      'Upgrade Your Setup Today',
      'Rated 4.8★ by 12,000 Buyers',
      'Limited Drop — Shop Now',
    ],
    descriptions: [
      'Discover best-sellers loved by thousands. Free returns within 30 days.',
      'Fast shipping, easy returns, and support that actually responds.',
      'Trusted by 12,000+ customers. Find your new favorite today.',
      'Quality you can feel. Prices you will love. Shop the new collection.',
    ],
  },
  anomalies: [
    { id: 'an_1', campaign_id: 'cmp_1004', metric: 'roas', direction: 'down', severity: 'high', description: 'TikTok — Awareness ROAS fell below break-even (1.4).' },
    { id: 'an_2', campaign_id: 'cmp_1005', metric: 'roas', direction: 'down', severity: 'high', description: 'Shopping — Catalog is unprofitable (ROAS 0.8) while still spending.' },
  ],
  copilotAnswer: {
    answer: 'Your blended ROAS is 3.4. Retargeting — Meta (6.0) and Brand — Search (5.0) are your winners; shift budget there from TikTok — Awareness (1.4).',
    cited_metrics: [
      { label: 'Blended ROAS', value: '3.4' },
      { label: 'Top channel', value: 'Meta retargeting' },
    ],
  },
  anomalySettings: { enabled: true, sensitivity: 'medium' },
};
